<template>
  <div class="photo">
    <img v-if="!popover"
         :src="src"
         alt=""
         :style="[tableData.style]">

    <el-popover class="popover"
                v-else
                trigger="hover"
                placement="top"
                v-for="(photo, index) in alllist"
                :key="index">
      <!-- 插入 -->
      <div class="nest">
        <div class="nest-name">{{photo.nickname || ''}}</div>
        <div class="nest-site">
          <div class="mailbox">{{photo.mailbox}}</div>
          <div class="privateMailbox">{{photo.privateMailbox}}</div>
        </div>
      </div>
      <!-- 嵌套 -->
      <div class="user-info"
           slot="reference">
        <div class="photo">
          <img :src="photo.headUrl || require('@/assets/default.png')">
        </div>
        <div class="name"
             v-if="photo.nickname">{{photo.nickname || ''}}</div>
        <div class="hint"
             v-if="hint">等{{hint}}人</div>
      </div>
    </el-popover>
    <div v-if="showImg && popover"
         class="show-img">未跟进</div>
  </div>
</template>

<script>
export default {
  props: {
    tableData: Object,
    scope: Object
  },
  data () {
    return {}
  },
  computed: {
    src () {
      if (this.popover) return ''
      if (this.tableData.formatter)
        return this.tableData.formatter(
          this.scope.row[this.tableData.bind],
          this.scope.row,
          this.tableData
        )
      return this.scope.row[this.tableData.bind]
    },
    hint () {
      let { row } = this.scope
      if (!this.tableData.hint) return false
      return this.tableData.hint(row, this.tableData)
    },
    popover () {
      return this.tableData.popover || false
    },
    alllist () {
      if (!this.popover) return []
      return (
        this.tableData.formatter &&
        this.tableData.formatter(this.scope.row, this.tableData)
      )
    },
    showImg () {
      return this.alllist && this.alllist.length == 0 ? true : false
    }
  },
  methods: {},
  components: {}
}
</script>

<style lang="scss" scoped>
.photo {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .popover {
    display: block;
    width: 100%;
  }
  .user-info {
    width: 100%;
    // width: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: o auto;
    .photo {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .name {
      /* 单行溢出 */
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .hint {
      color: rgb(175, 175, 175);
    }
  }
}
.show-img {
  width: 100%;
  // width: 150px;
  text-align: center;
}
.nest-site {
  .privateMailbox,
  .mailbox {
    margin: 3px 0px;
  }
}
img {
  object-fit: contain;
}
</style>
